<template>
    <div class="row-actions">
        <button class="btn btn--danger" @click="cancelBooking">Отменить бронирование</button>
    </div>
</template>

<script setup lang="ts">
import { request } from '@/admin/shared/api/httpClient';

const props = defineProps<{ detail: { id: number | string } }>();

async function cancelBooking(): Promise<void> {
    const reason = prompt('Причина отмены:');
    if (!reason) return;
    await request({
        method: 'post',
        url: `/admin-api/bookings/${props.detail.id}/cancel/`,
        data: { reason },
    });
    window.location.reload();
}
</script>

<style scoped>
.row-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 1rem;
}

@media (max-width: 640px) {
    .row-actions .btn { min-height: 2.5rem; }
}
</style>
